import { SettingConst } from '@faire/web-api--source/types';

/**
 * Feature toggle to show new UI for account settings left nav
 * @deprecated Feature has been rolled out and setting will be removed once client usages are removed
 */
export const ENABLE_ACCOUNT_SETTINGS_LEFT_NAV_V2_UI_240808 =
  'ENABLE_ACCOUNT_SETTINGS_LEFT_NAV_V2_UI_240808' as SettingConst<
    'ENABLE_ACCOUNT_SETTINGS_LEFT_NAV_V2_UI_240808',
    boolean,
    'LOGGED_IN_RETAILER'
  >;
